import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useCommonApi() {
  const callApi = useApiCall();

  const GetCountyList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_COUNTY, data, onSuccess, onError);
  };

  const GetStateList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_STATE, data, onSuccess, onError);
  };
  
  const GetCityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_CITY, data, onSuccess, onError);
  };
  
  const GetteamList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_TEAM, data, onSuccess, onError);
  };
  

  const GetUserList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_USER, data, onSuccess, onError);
  };
  const GetServicetectList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_SERVICE_TECH, data, onSuccess, onError);
  };

  const GetServiceprovidertList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_SERVICE_PROVIDER_LIST, data, onSuccess, onError);
  };
  const getTaxes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.GET_TAXES, data, onSuccess, onError);
  };
  
  const DeleteTeam = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.COMMON.DELETE_TEAM, data, onSuccess, onError);
  };


  return {
    GetCountyList,
    GetStateList,
    GetCityList,
    GetteamList,
    GetUserList,
    GetServicetectList,
    GetServiceprovidertList,
    getTaxes,
    DeleteTeam
  };
}
